var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryEg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7832)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#E41D33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3686 9.4824L12.6529 10.0509L12.9588 9.49398L12.9588 9.49396L12.9589 9.49391L12.9589 9.49382L12.959 9.49366L12.9601 9.49162L12.9654 9.48219C12.9703 9.4736 12.9777 9.46052 12.9875 9.44361C13.0072 9.40975 13.0364 9.3607 13.0733 9.30155C13.1476 9.18264 13.2514 9.0259 13.3716 8.8708C13.4933 8.71374 13.6235 8.56902 13.749 8.46658C13.883 8.3572 13.9662 8.33333 14.0001 8.33333C14.0574 8.33333 14.1512 8.3644 14.2814 8.46862C14.4071 8.56914 14.5336 8.71141 14.6501 8.86667C14.7651 9.01999 14.8622 9.17512 14.9309 9.29296C14.9651 9.35153 14.9917 9.40005 15.0096 9.43345C15.0186 9.45013 15.0253 9.46298 15.0296 9.47137L15.0343 9.48049L15.0353 9.48238L15.0353 9.4824L15.0353 9.48251L15.0354 9.48258L15.0354 9.48263L15.3334 10.0787L15.6316 9.4824L16.2061 8.33333L16.6667 8.33333C16.8508 8.33333 17.0001 8.48257 17.0001 8.66667V10.7543C17.0001 11.0206 16.7034 11.1794 16.4818 11.0317L15.5183 10.3893L15.4343 10.3333H15.3334H14.6667H14.3334V10.6667V11.3333C14.3334 11.5174 14.1842 11.6667 14.0001 11.6667C13.816 11.6667 13.6667 11.5174 13.6667 11.3333V10.6667V10.3333H13.3334H12.6667H12.5658L12.4818 10.3893L11.5183 11.0317C11.2968 11.1794 11.0001 11.0206 11.0001 10.7543V8.66667C11.0001 8.48257 11.1493 8.33333 11.3334 8.33333L11.7941 8.33333L12.3686 9.4824Z",
    fill: "#F4B32E",
    fillOpacity: 0.25,
    stroke: "#C6A846",
    strokeWidth: 0.666667
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7832"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryEg);
export default __webpack_public_path__ + "static/media/Country=EG.6370091495e9c7ca2cb4855dd60e19e2.svg";
export { ForwardRef as ReactComponent };